import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";

// Closing CTA band shown at the foot of every subpage (except /contact itself).
const ContactCTA = ({
    heading = "Let's build",
    accent = "what matters.",
    sub = "Tell us which lane you're in. A real human replies within one business day - never a templated email.",
}) => (
    <section className="relative py-20 lg:py-28 border-t border-gold/10" data-testid="contact-cta-band">
        <div className="max-w-4xl mx-auto px-5 lg:px-10 text-center">
            <h2 className="font-display text-4xl lg:text-5xl text-ivory tracking-tight">
                {heading} <span className="italic text-gold-shimmer">{accent}</span>
            </h2>
            <p className="mt-4 text-ivory/65 max-w-xl mx-auto">{sub}</p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
                <Link to="/contact" className="btn-gold" data-testid="cta-schedule-call">
                    Schedule a call <ArrowUpRight className="w-4 h-4" />
                </Link>
                <a href="mailto:admin@indoblitz.com" className="btn-ghost" data-testid="cta-email">
                    <Mail className="w-4 h-4" /> admin@indoblitz.com
                </a>
            </div>
        </div>
    </section>
);

export default ContactCTA;
